import { DialogDescription } from '@/components/ui/dialog';

interface OpeningHoursImpactDescriptionProps {
  affectedStaffCount: number;
  affectedBookingCount: number;
}

export function OpeningHoursImpactDescription({
  affectedStaffCount,
  affectedBookingCount,
}: OpeningHoursImpactDescriptionProps) {
  return (
    <DialogDescription asChild>
      <div className="flex flex-col gap-3 text-left">
        <p>
          {affectedStaffCount > 0
            ? `${affectedStaffCount} staff ${affectedStaffCount === 1 ? 'rota' : 'rotas'} will be affected. Shifts will be shortened or removed.`
            : 'No staff rotas will be affected.'}
        </p>
        <p>Bookings completely outside the new hours will stay unchanged.</p>
        <p>
          {affectedBookingCount > 0
            ? `${affectedBookingCount} future ${affectedBookingCount === 1 ? 'booking' : 'bookings'} will be moved or shortened to fit, or cancelled if ${affectedBookingCount === 1 ? 'it cannot' : 'they cannot'} fit.`
            : 'No future bookings will be affected.'}
        </p>
      </div>
    </DialogDescription>
  );
}
